const FieldPodrocja = ({ label, arrs, cerif, klasius }) => {
  return (
    <div className="mb-2">
      <span className="field-label">{label}: </span>
      <div className="mx-2">
        {arrs !== null && <div>{arrs}</div>}
        {cerif !== null && <div>{cerif}</div>}
        {klasius !== null && <div>{klasius}</div>}
      </div>
    </div>
  );
};

export default FieldPodrocja;
